export default __webpack_public_path__ + "static/media/promo.b4701a96.png";